import type { ReactNode } from 'react';

type AppPageTitleSectionProps = {
  title: string;
  subtitle?: string;
  /** Inline control next to the title (e.g. help ? popover). */
  titleAccessory?: ReactNode;
  children?: ReactNode;
  /** Absolutely positioned inside the section root (e.g. bottom-aligned trailing art). */
  endDecoration?: ReactNode;
  className?: string;
  showDivider?: boolean;
};

/** Page title block — same layout as Employer Task Management; optional right-side slot (e.g. 3-dot menu). */
export const AppPageTitleSection = ({
  title,
  subtitle,
  titleAccessory,
  children,
  endDecoration,
  className = '',
  showDivider = true,
}: AppPageTitleSectionProps) => (
  <div
    className={[
      'relative mb-5 overflow-visible',
      showDivider ? 'border-b border-gray-200/70 pb-4 dark:border-gray-800' : '',
      className,
    ]
      .filter(Boolean)
      .join(' ')}
  >
    {endDecoration}
    <div className="relative z-10 flex items-start justify-between gap-3">
      <div className="min-w-0">
        <div className="flex items-center gap-1.5">
          <h1 className="text-xl font-bold tracking-tight text-gray-900 dark:text-gray-100">{title}</h1>
          {titleAccessory}
        </div>
        {subtitle ? (
          <p className="mt-0.5 text-xs text-gray-500 dark:text-gray-400">{subtitle}</p>
        ) : null}
      </div>
      {children}
    </div>
  </div>
);
